module.exports = __webpack_public_path__ + "static/media/ChromecastConnectingStep2Icon.b3759a88.svg";